/**
 * @generated SignedSource<<ca0bff54ce95f74433b5773452a27b2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModuleVariant_viewer$data = {
  readonly trendingCreators: ReadonlyArray<{
    readonly category: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleItemVariant_trendingCreator">;
  } | null> | null;
  readonly " $fragmentType": "HpSharedShopByModuleVariant_viewer";
};
export type HpSharedShopByModuleVariant_viewer$key = {
  readonly " $data"?: HpSharedShopByModuleVariant_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleVariant_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModuleVariant_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TrendingCreator",
      "kind": "LinkedField",
      "name": "trendingCreators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedShopByModuleItemVariant_trendingCreator"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4ed967fff35a899ba611823dd5a822d4";

export default node;
